export const manageSubscriptionsIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Manage Subscriptions page is where you can customize Diagnostic schedules.'
  },
  {
    element: '#customizeDiagnosticSchedule',
    intro: 'Contact your WordFlight Implementation Lead to learn more about changing the schedule of a Diagnostic.'
  },
];